"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleHistory = void 0;
class VehicleHistory {
    isWritenOff() {
        return this.hasWrittenOffHistory;
    }
    setWritenOff(isWrittenOff) {
        this.hasWrittenOffHistory = isWrittenOff;
        return this;
    }
    isStolen() {
        return this.stolen;
    }
    setStolen(isStolen) {
        this.stolen = isStolen;
        return this;
    }
    getRegistrationStatus() {
        return this.registrationStatus;
    }
    setRegistrationStatus(status) {
        this.registrationStatus = status;
        return this;
    }
}
exports.VehicleHistory = VehicleHistory;
exports.default = VehicleHistory;
